import { render, staticRenderFns } from "./RecepcionesActividad.vue?vue&type=template&id=7fa62af9&"
import script from "./RecepcionesActividad.vue?vue&type=script&lang=ts&"
export * from "./RecepcionesActividad.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports